import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,5.68434189e-14 C1130.65412,5.68434189e-14 1299.04941,46.08 1447.11529,133.157647 L1389.85412,230.512941 C1259.06824,153.6 1110.43765,112.941176 960,112.941176 C492.875294,112.941176 112.941176,492.875294 112.941176,960 C112.941176,1427.12471 492.875294,1807.05882 960,1807.05882 C1427.12471,1807.05882 1807.05882,1427.12471 1807.05882,960 C1807.05882,809.449412 1766.4,660.818824 1689.48706,530.032941 L1786.72941,472.884706 C1873.92,620.950588 1920,789.345882 1920,960 C1920,1489.35529 1489.35529,1920 960,1920 C430.644706,1920 0,1489.35529 0,960 C0,430.644706 430.644706,5.68434189e-14 960,5.68434189e-14 Z M960,338.823529 L960,451.764706 C679.792941,451.764706 451.764706,679.792941 451.764706,960 C451.764706,1240.20706 679.792941,1468.23529 960,1468.23529 C1240.20706,1468.23529 1468.23529,1240.20706 1468.23529,960 L1581.17647,960 C1581.17647,1302.55059 1302.43765,1581.17647 960,1581.17647 C617.562353,1581.17647 338.823529,1302.55059 338.823529,960 C338.823529,617.449412 617.562353,338.823529 960,338.823529 Z M960,677.647059 L960,790.588235 C866.597647,790.588235 790.588235,866.597647 790.588235,960 C790.588235,1053.40235 866.597647,1129.41176 960,1129.41176 C1053.40235,1129.41176 1129.41176,1053.40235 1129.41176,960 L1242.35294,960 C1242.35294,1115.63294 1115.74588,1242.35294 960,1242.35294 C804.254118,1242.35294 677.647059,1115.63294 677.647059,960 C677.647059,804.367059 804.254118,677.647059 960,677.647059 Z M1823.41271,16.4668235 L1903.37506,96.3162353 L1322.145,677.647 L1581.17647,677.647059 L1581.17647,790.588235 L1129.41176,790.588235 L1129.41176,338.823529 L1242.35294,338.823529 L1242.352,597.729 L1823.41271,16.4668235 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconOutcomesLine = /*#__PURE__*/function (_Component) {
  _inherits(IconOutcomesLine, _Component);

  var _super = _createSuper(IconOutcomesLine);

  function IconOutcomesLine() {
    _classCallCheck(this, IconOutcomesLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconOutcomesLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconOutcomes",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconOutcomesLine.displayName = "IconOutcomesLine";
  return IconOutcomesLine;
}(Component);

IconOutcomesLine.glyphName = 'outcomes';
IconOutcomesLine.variant = 'Line';
IconOutcomesLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconOutcomesLine;
export { IconOutcomesLine };